import { useState, useEffect, useCallback } from 'react';
import { DashboardStats } from '../types';
import { apiService, APIError } from '../services/api';

interface UseDashboardState {
  stats: DashboardStats | null;
  loading: boolean;
  error: APIError | null;
  lastUpdated: Date | null;
}

export const useDashboard = () => {
  const [state, setState] = useState<UseDashboardState>({
    stats: null,
    loading: false,
    error: null,
    lastUpdated: null,
  });

  const loadStats = useCallback(async () => {
    setState(prev => ({ ...prev, loading: true, error: null }));

    try {
      const stats = await apiService.getDashboardStats();
      setState(prev => ({
        ...prev,
        stats,
        loading: false,
        lastUpdated: new Date(),
      }));
    } catch (error) {
      const apiError =
        error instanceof APIError
          ? error
          : new APIError('Error al cargar estadísticas');
      setState(prev => ({
        ...prev,
        loading: false,
        error: apiError,
      }));
    }
  }, []);

  const refreshStats = useCallback(() => {
    loadStats();
  }, [loadStats]);

  // Auto-refresh cada 30 segundos
  useEffect(() => {
    loadStats();

    const interval = setInterval(() => {
      loadStats();
    }, 30000);

    return () => clearInterval(interval);
  }, [loadStats]);

  return {
    ...state,
    refreshStats,
  };
};
